import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia?',
  answer: 'No. Está explicado desde cero, con pasos claros.'
}, {
  question: '¿De verdad no tengo que mostrar mi cara?',
  answer: 'Correcto. Ese es el punto: construir sin exposición.'
}, {
  question: '¿Cuánto tiempo necesito?',
  answer: 'Para empezar: 2–4 horas en la primera semana para montar la base. Después: 20–30 min al día para mantener constancia.'
}, {
  question: '¿Sirve para cualquier nicho?',
  answer: 'Sí. Te damos la metodología y ejemplos para adaptarlo a distintos nichos.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Tras el pago, recibes el acceso por email (descarga inmediata).'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 bg-alt" data-id="element-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9">
        <h2 className="text-3xl font-serif text-center text-title mb-12" data-id="element-10">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-11">
          {faqs.map((faq, index) => <div key={index} className="bg-card border border-[#D9D0C1] overflow-hidden" data-id="element-12">
              <button className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-13">
                <span className={`font-medium ${openIndex === index ? 'text-accent' : 'text-title'}`} data-id="element-14">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus size={20} className="text-accent" data-id="element-15" /> : <Plus size={20} className="text-body" data-id="element-16" />}
              </button>

              <div className={`px-6 text-body text-sm transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 py-4 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-17">
                {faq.answer}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}